// @ts-nocheck
import React from 'react';

export function MenuItemLabel({ text }) {
  return <span class="bp4-menu-item-labeler">{text}</span>;
}
